var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-left-panel",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"el-icon-edit-outline icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }